<div class="flex row" style="margin-bottom: 2rem;">
  <div class="flex column reviews">
    <div class="flex row review" *ngFor="let rating of ratings">
      <div class="rating">{{rating.score}}</div>
      <div class="wrapper">
        <div class="progress-bar">
          <span class="progress-bar-fill" [style.width.%]="rating.percentage"></span>
        </div>
      </div>
    </div>
  </div>
  <div class="card-container" *ngIf="hasBadges(); else noBadgesTemplate" >
  <div class="card_badge" *ngFor="let badge of badges top4Badges">
    <div class="card_header_badge">
      <div class="icon">
        <svg-icon style="height: 40px" [svgStyle]="{'width.px': 40}" [src]="badge.icon"></svg-icon>
      </div>
    </div>
    <div class="card_content_badge">
      <div class="card_subheader_badge">
        {{badge.name}}
      </div>
      <div class="card_text_badge">
        {{badge.count}}&nbsp;Votes
      </div>
    </div>
  </div>
</div>
<ng-template #noBadgesTemplate>
  <div class="card_flat green-gradient">
    <div class="card_header">
      <div class="rating-number">{{ overallRating | number: '1.0-2' }}</div>
    </div>
    <div class="stars-row">
      <img *ngFor="let star of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; let i = index"
           src="assets/icons/star_rating.svg" 
           [class.filled]="i < roundedCombinedRating"
           alt="Star" />
    </div>
  
    <div class="card_content">
      <div class="card_subheader">Awesome!</div>
    </div>
    <div class="card_footer">
      <svg-icon style="height: 24px" [svgStyle]="{'width.px': 24,'fill': 'white'}" src="/assets/icons/chat.svg"></svg-icon>
      <span class="review-total">{{ totalReviews }} reviews</span>
    </div>
  </div>

  <!-- Second Card: Travelers with gray background -->
  <div class="card_flat light-background">
    <div class="card_header">
      <svg-icon style="height: 60px" [svgStyle]="{'width.px': 60, 'height.px': 60,}" src="/assets/icons/user_2.svg"></svg-icon>
    </div>
    <div class="card_content">
      <div class="card_subheader">{{ randomTravelers }} other travelers</div>
      <div class="card_text">
        Will be staying at this hostel between the selected dates
      </div>
    </div>
  </div>

  <!-- Third Card: Recommendation with gray background -->
  <div class="card_flat light-background">
    <div class="card_header">
      <svg-icon style="height: 60px" [svgStyle]="{'width.px': 60, 'height.px': 60}" src="/assets/icons/thumb.svg"></svg-icon>
    </div>
    <div class="card_content">
      <div class="card_subheader">Recommend this hostel</div>
      <div class="card_text">
        Recommend this hostel to another traveler to earn 4% of their booking
      </div>
    </div>
  </div>
</ng-template>
</div>
